import { ThinkModelComponent } from './../../../shared/model/fitup/generic.model';
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { FitupService } from '../../../shared/service/fitup/fitup.service';

interface FooterTextLinkItem {
  footerLink: string;
  footerText: string;
  id: number;
}

@Component({
  selector: 'app-modern-footer',
  templateUrl: './modern-footer.component.html',
  styleUrls: ['./modern-footer.component.scss']
})
export class ModernFooterComponent implements OnInit {
  private readonly _fitUpSvc = inject(FitupService)
  private appModernFooter?: ThinkModelComponent
  public year?: number
  public copyrightText?: string
  public footerTextLinks?: FooterTextLinkItem[]

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    const navEl = document.querySelector('.nav-abs');
    if (navEl) window.pageYOffset > 75 ? navEl.classList.add('navbar-scrolled') : navEl.classList.remove('navbar-scrolled');
  }
  ngOnInit(): void {
    this.getDados();
    this.getDate()
  }
  getDados(): void {
    this._fitUpSvc.getStrapiDataObservable().subscribe(updateData => {
      this.appModernFooter = updateData
      const component = this._fitUpSvc.getComponentData('app_modern_footer').data.attributes
      this.copyrightText = component.copyrightText
      this.footerTextLinks = component.footerTextLink
    })
  }

  getDate(): number {
    return this.year = new Date().getFullYear()
  }

}
